<template>
    <modal @close="editEmailAddressCancelClick" hideFooter id="edit-email-address" style="max-width: 800px;">
        <div class="td-container">
            <h3>Edit Email Address</h3>
            <div v-if="isAdmin">
                <p>Enter a new email address for this user.</p>
                <p>
                    The changes will be applied immediately, no verification is required.
                </p>
            </div>
            <div v-else>
                <p>A verification email will be sent to the new email address before changes are applied.</p>
            </div>

            <label class="td-label td-text-bold mt-0">New Email Address:</label>
            <div class="td-banner danger slim my-1" v-if="errorMessage.length > 0">
                <icon class="icon" type="solid" name="faTriangleExclamation" aria-hidden="true"></icon>
                <div> {{ errorMessage }}</div>
            </div>

            <div v-if="isAdmin">
                <p>
                    <input type="text" v-model="newEmail" />
                </p>
                <p v-if="v$.newEmail.$error" class="td-error">Please enter a valid email.</p>
                <p>
                    <button class="td-btn primary" @click="updateEmailAdmin">
                        Save
                    </button>
                </p>
            </div>
            <div v-else>
                <AddressValidator @validated="updateEmail"
                                  :reset="usernameResetTrigger"
                                  :disable-sms="true"
                                  :disable-validation="false"
                                  :disable-password="true"
                                  :validation-failed="false"
                                  :enable-username="false" v-model="newEmail"
                                  :with-password="false"
                                  :update-existing="true"
                                  placeholder="Enter email">
                </AddressValidator>
            </div>

        </div>
    </modal>
</template>

<script>
    import script from './EditEmailAddress';
    export default script;
</script>
<style lang="less">
    @import './EditEmailAddress.less';
</style>